import { useEffect, useRef } from 'react';
import { X } from 'lucide-react';
import { QUICK_ADD_OPTIONS, type ViewId } from '../layout/navigation';

type Props = {
  open: boolean;
  onClose: () => void;
  onChoose: (viewId: ViewId) => void;
};

export const QuickAddDialog = ({ onChoose, onClose, open }: Props) => {
  const dialogRef = useRef<HTMLDialogElement>(null);

  useEffect(() => {
    const dialog = dialogRef.current;
    if (!dialog) return;
    if (open && !dialog.open) dialog.showModal();
    if (!open && dialog.open) dialog.close();
  }, [open]);

  return (
    <dialog className="quick-add-dialog" ref={dialogRef} onCancel={onClose} onClose={onClose}>
      <div className="dialog-heading">
        <div>
          <p className="eyebrow">Quick capture</p>
          <h2>What would you like to plan?</h2>
        </div>
        <button type="button" className="icon-button" aria-label="Close quick add" onClick={onClose}>
          <X size={20} aria-hidden="true" />
        </button>
      </div>
      <p className="dialog-intro">Choose what to add. It will be saved only in this browser and device.</p>
      <div className="quick-add-options">
        {QUICK_ADD_OPTIONS.map(({ description, icon: Icon, id, label }) => (
          <button type="button" className="quick-add-option" key={id} onClick={() => onChoose(id)}>
            <span className="quick-add-icon"><Icon size={22} aria-hidden="true" /></span>
            <span><strong>{label}</strong><small>{description}</small></span>
          </button>
        ))}
      </div>
    </dialog>
  );
};
